/*
 * @Author: Teemo Ding
 * @Date: 2021-10-28 16:58:00
 * @LastEditTime: 2023-03-15 13:43:56
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/GiftCardAndStoreCredit/List/config.tsx
 */
import { EGiftCardType } from '@/src/types/common/order';
import React from 'react';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import StatusTag from 'src/components/StatusTag';
import { EnumFilterType } from 'src/constrains/Query1/Filter';
import {
  fulfillmentStatusesText,
  paymentStatusText,
  statusText,
} from 'src/pages/Order/config';
//import css from './css.module.less';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { EnumStatus, EnumTablePosition } from 'src/types/common/common';

export {
  ETab,
  breadcrumbData,
  columns,
  filterList,
  fulfillmentStatusesText,
  paymentStatusText,
  statusText,
  tabDict,
  tabsConfig,
};

enum ETab {
  all = 'all',
  active = 'active',
  inactive = 'inactive',
}

const tabDict = {
  [ETab.all]: [
    EnumStatus.Active,
    EnumStatus.Expired,
    EnumStatus.ZeroBalance,
    EnumStatus.Locked,
    // EnumStatus.Inactive,
  ],
  [ETab.active]: [EnumStatus.Active],
  [ETab.inactive]: [
    EnumStatus.Expired,
    EnumStatus.ZeroBalance,
    EnumStatus.Locked,
  ],
};

const tabsConfig = (getI18n) => [
  //定义tabs列表
  {
    name: getI18n('general.all'),
    key: ETab.all,
  },
  {
    name: getI18n(
      'giftCard.giftCardDetail.giftcardinfo_statustag_list_activetag',
    ),
    key: ETab.active,
  },
  {
    name: getI18n('general.status.inactive'),
    key: ETab.inactive,
  },
];

const filterList = (currencies, props, getI18n) => {
  const { isTabOnActive, isTabOnInActive } = props;
  return [
    {
      type: EnumFilterType.MultipleSelection,

      dropdownProps: { name: getI18n('general.currency') },
      keyWord: 'currencies',
      options: currencies.map((item) => ({
        label: item.name,
        value: item.code,
      })),
    },
    ...(isTabOnActive
      ? []
      : [
          {
            type: EnumFilterType.MultipleSelection,
            dropdownProps: { name: getI18n('general.status') },
            keyWord: 'statuses',
            options: [
              ...(isTabOnInActive
                ? []
                : [
                    {
                      label: getI18n(
                        'giftCard.giftCardDetail.giftcardinfo_statustag_list_activetag',
                      ),
                      value: EnumStatus.Active,
                    },
                  ]),
              {
                label: getI18n(
                  'giftCard.giftCardDetail.giftcardinfo_statustag_list_expiretag',
                ),
                value: EnumStatus.Expired,
              },
              {
                label: getI18n(
                  'giftCard.giftCardDetail.giftcardinfo_statustag_list_locktag',
                ),
                value: EnumStatus.Locked,
              },
              {
                label: getI18n(
                  'giftCard.giftCardDetail.giftcardinfo_statustag_list_zerotag',
                ),
                value: EnumStatus.ZeroBalance,
              },
            ],
          },
        ]),
    {
      type: EnumFilterType.MultipleSelection,
      dropdownProps: { name: getI18n('general.type') },
      keyWord: 'types',
      options: [
        {
          label: getI18n('giftCard.giftCardDetail.giftcardinfo_giftcardtitile'),
          value: EGiftCardType.GiftCard,
        },
        {
          label: getI18n(
            'giftCard.giftCardList.giftCardAndStoreCredit_List_config_StoreCredit_lable',
          ),
          value: EGiftCardType.StoreCreditCard,
        },
      ],
    },
  ];
};

const breadcrumbData = (getI18n) => [
  {
    url: '',
    name: getI18n('general.sider.home'),
  },
  {
    url: '',
    name: getI18n('general.storeCommunicationSetting.order'),
  },
  {
    url: '',
    name: getI18n
      ? getI18n(
          'giftCard.giftCardList.giftCardAndStoreCredit_List_pageLayoutProps_title',
        )
      : 'Gift Card and Store Credit',
  },
];

const columns = (gotoEdit, disableView: boolean, getI18n: any) => [
  {
    title: getI18n('giftCard.giftCardDetail.issueinfo_return_cardnumber_title'),
    textTitle: getI18n(
      'giftCard.giftCardDetail.issueinfo_return_cardnumber_title',
    ),
    dataIndex: 'cardNo',
    key: 'Sku',
    default: true,
    optional: true,
    sorter: true,
    childGenerate: (text, record) => (
      <NoWrapContainer>
        <GlobalTooltip title={text}>{text}</GlobalTooltip>
      </NoWrapContainer>
    ),
    minWidth: 160,
  },
  {
    title: getI18n(
      'giftCard.giftCardList.giftCardAndStoreCredit_List_config_orderno',
    ),
    textTitle: getI18n(
      'giftCard.giftCardList.giftCardAndStoreCredit_List_config_orderno',
    ),
    dataIndex: ['order', 'orderNo'],
    default: false,
    optional: true,
    position: EnumTablePosition.mid,
    key: 'orderNo',
    width: 100,
  },
  {
    title: getI18n('giftCard.giftCardDetail.issueinfo_return_customer_title'),
    textTitle: getI18n(
      'giftCard.giftCardDetail.issueinfo_return_customer_title',
    ),
    dataIndex: ['customer', 'uuid'],
    default: false,
    optional: true,
    position: EnumTablePosition.mid,
    key: 'customer',
    width: 100,
  },
  {
    title: getI18n('general.status'),
    textTitle: getI18n('general.status'),
    dataIndex: 'status',
    default: true,
    optional: true,
    sorter: true,
    position: EnumTablePosition.mid,
    childGenerate: (text, _, index) => {
      return <StatusTag status={text} />;
    },
    key: 'Status',
    width: 80,
  },
  {
    title: getI18n('general.currency'),
    dataIndex: 'currency',
    default: true,
    optional: true,
    key: 'currency',
    minWidth: 128,
  },
  {
    title: getI18n(
      'giftCard.giftCardList.giftCardAndStoreCredit_List_config_Remaining',
    ),
    dataIndex: 'balance',
    default: true,
    optional: true,
    sorter: true,
    key: 'Remaining',
    childGenerate: (text, record) => (
      <NoWrapContainer>
        <GlobalTooltip title={text}>{text}</GlobalTooltip>
      </NoWrapContainer>
    ),
    minWidth: 128,
  },
  {
    title: getI18n('giftCard.giftCardDetail.giftcardinfo_data_denotitle'),
    textTitle: getI18n('giftCard.giftCardDetail.giftcardinfo_data_denotitle'),
    dataIndex: 'total',
    default: false,
    optional: true,
    position: EnumTablePosition.mid,
    key: 'denomination',
    childGenerate: (text, record) => (
      <NoWrapContainer>
        <GlobalTooltip title={text}>{text}</GlobalTooltip>
      </NoWrapContainer>
    ),
    width: 100,
  },
  {
    title: getI18n('general.type'),
    dataIndex: 'type',
    default: true,
    optional: true,
    sorter: true,
    key: 'Type',
    minWidth: 128,
    childGenerate: (text, record) => {
      const d =
        {
          [EGiftCardType.GiftCard]: getI18n(
            'giftCard.giftCardDetail.giftcardinfo_giftcardtitile',
          ),
          [EGiftCardType.StoreCreditCard]: getI18n(
            'giftCard.giftCardDetail.giftcardinfo_storetitile',
          ),
        }[text] || '-';
      return (
        <NoWrapContainer>
          <GlobalTooltip title={d}>{d}</GlobalTooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: getI18n('giftCard.giftCardDetail.giftcardinfo_data_issuetitle'),
    dataIndex: 'createdDate',
    default: true,
    optional: true,
    sorter: true,
    key: 'IssuedDate',
    minWidth: 160,
    childGenerate: (text, record) => (
      <NoWrapContainer>
        <GlobalTooltip title={text}>{text || '-'}</GlobalTooltip>
      </NoWrapContainer>
    ),
  },
  {
    title: getI18n('giftCard.giftCardDetail.giftcardinfo_data_expiretitle'),
    dataIndex: 'expireAt',
    default: true,
    optional: true,
    sorter: true,
    key: 'ExpirationDate',
    minWidth: 160,
    childGenerate: (text, record) => (
      <NoWrapContainer>
        <GlobalTooltip title={text}>{text || '-'}</GlobalTooltip>
      </NoWrapContainer>
    ),
  },
  {
    titleGenerate: () =>
      getI18n('general.advancedFilters.commonStoreProductsWithTable.actions'),
    position: EnumTablePosition.mid,
    key: 'Actions',
    default: true,
    childGenerate: (url, record, index) => {
      return disableView ? (
        '-'
      ) : (
        <Actions onEdit={() => gotoEdit(record.uuid)} />
      );
    },
    width: 80,
  },
];
